export default __webpack_public_path__ + "static/media/builtEbloc.e4f62b69.png";